import React, { Component } from "react";
import {
  Button,
  Container,
  Dropdown,
  Grid,
  Header,
  Image,
  Message,
  Popup,
  Segment
} from "semantic-ui-react";

import DropzoneCommon from "../../components/content/DropzoneCommon"
import set from "lodash/set";
import { ChromePicker } from "react-color";
import request from "../../utils/request";

const invertColor = (hex, bw) => {
  if (hex === "") {
    hex = "#000000"
  }
  if (hex.indexOf("#") === 0) {
    hex = hex.slice(1);
  }
  // convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    throw new Error("Invalid HEX color.");
  }
  var r = parseInt(hex.slice(0, 2), 16),
    g = parseInt(hex.slice(2, 4), 16),
    b = parseInt(hex.slice(4, 6), 16);
  if (bw) {
    // http://stackoverflow.com/a/3943023/112731
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
  }
  // invert color components
  r = (255 - r).toString(16);
  g = (255 - g).toString(16);
  b = (255 - b).toString(16);
  // pad each with zeros and return
  return "#" + padZero(r) + padZero(g) + padZero(b);
};

const padZero = (str, len) => {
  len = len || 2;
  var zeros = new Array(len).join("0");
  return (zeros + str).slice(-len);
};

class Tablet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMounted: false,
      isLoading: true,
      xhrStatus: "",
      xhrMessage: "",
      nonProfit: {
        alt1_bg: "#de1630",
        alt1_text: "#ffffff",
        alt2_bg: "#de1630",
        alt2_text: "#ffffff",
        hl1_text: "#000000",
        hl1_bg: "#ffffff",
        spacerbar: "#ffffff"
      },
      nonProfitList: [],
      nonProfitOptions: [
        {
          key: 0,
          text: "Select Non-profit",
          value: 0
        }
      ],
      nonProfitId: 0,
      tablet: {
        left: '',
        right: '',
      }
    };
  }
  componentDidMount = () => {
    this.setState({ isMounted: true });
    this.fetchData();
  };
  startLoading = () => {
    this.setState({ isLoading: true }); 
  }
  doneLoading = () => {
    this.setState({ isLoading: false }); 
  }
  fetchData = () => {
    this.startLoading();
    return request.get(this, "api:/non-profit", {ts: Date.now()}).then(resp => {
      let nonProfitOptions = this.state.nonProfitOptions;
      let nonProfitList = [];
      resp.data.map((value, index) => {
        nonProfitList[+value.id] = value;
        return nonProfitOptions.push({
          key: value.id,
          text: value.name,
          value: value.id
        });
      });
      this.setState({
        nonProfitList: nonProfitList,
        nonProfitOptions: nonProfitOptions,
        isLoading: false,
      });
    });
  };
  handleNonProfit = (e, { value }) => {
    if (+value === 0) return;
    let nonProfit = this.state.nonProfitList[value];
    nonProfit['alt1_bg'] = nonProfit.alt1_bg ? nonProfit.alt1_bg : "#de1630";
    nonProfit['alt1_text'] = nonProfit.alt1_text ? nonProfit.alt1_text : "#ffffff";
    nonProfit['alt2_bg'] = nonProfit.alt2_bg ? nonProfit.alt2_bg : "#000000";
    nonProfit['alt2_text'] = nonProfit.alt2_text ? nonProfit.alt2_text : "#ffffff";
    nonProfit['hl1_text'] = nonProfit.hl1_text ? nonProfit.hl1_text : "#000000";
    nonProfit['hl1_bg'] = nonProfit.hl1_bg ? nonProfit.hl1_bg : "#ffffff";
    nonProfit['spacerbar'] = nonProfit.spacerbar ? nonProfit.spacerbar : "#ffffff";
    this.setState({
      nonProfitId: +value,
      nonProfit: nonProfit,
      tablet: {
        left: this.state.nonProfitList[value].rsu_logo_left_url,
        right: this.state.nonProfitList[value].rsu_logo_right_url,
      },
      xhrStatus: "",
      xhrMessage: ""
    });
  };
  handleAlt1Bg = (color, event) => {
    let np = this.state.nonProfit;
    np.alt1_bg = color.hex;
    this.setState({ nonProfit: np });
  };
  handleAlt1Text = (color, event) => {
    let np = this.state.nonProfit;
    np.alt1_text = color.hex;
    this.setState({ nonProfit: np });
  };
  handleAlt2Bg = (color, event) => {
    let np = this.state.nonProfit;
    np.alt2_bg = color.hex;
    this.setState({ nonProfit: np });
  };
  handleAlt2Text = (color, event) => {
    let np = this.state.nonProfit;
    np.alt2_text = color.hex;
    this.setState({ nonProfit: np });
  };
  handleHl1Bg = (color, event) => {
    let np = this.state.nonProfit;
    np.hl1_bg = color.hex;
    this.setState({ nonProfit: np });
  };
  handleHl1Text = (color, event) => {
    let np = this.state.nonProfit;
    np.hl1_text = color.hex;
    this.setState({ nonProfit: np });
  };
  handleSpacerBar = (color, event) => {
    let np = this.state.nonProfit;
    np.spacerbar = color.hex;
    this.setState({ nonProfit: np });
  };
  handleTabletLeft = files => this.handleUpload(files[0], "left");
  handleTabletRight = files => this.handleUpload(files[0], "right");
  handleUpload = (file, position) => {
    // Initial FormData
    let formData = new FormData();
    formData.append("nonProfitId", this.state.nonProfitId);
    formData.append("imageFile", file);
    formData.append("imageTitle", position);

    return request.post(
      this,
      "api:/content/logo",
      formData,
      this.handleResponse
    );
  };
  handleResponse = resp => {
    this.setState({
      xhrStatus: resp.success,
      xhrMessage: resp.message
    });
    if (resp.success) {
      if (resp.data && resp.data.img_url) {
        let data = this.state.tablet;
        set(data, resp.data.img_title, resp.data.img_url);
        this.setState({ [resp.data.img_type]: data });
      }
    }
  };
  handleSubmit = () => {
    if (this.state.nonProfitId === 0) return;
    this.setState({
      isLoading: true,
      xhrStatus: "",
      xhrMessage: ""
    });
    return request.put(
      this,
      `api:/non-profit/${this.state.nonProfitId}`,
      this.state.nonProfit,
      this.saveProfile
    );
  };
  saveProfile = resp => {
    this.setState({
      xhrStatus: resp.success ? "success" : "error",
      xhrMessage: resp.success ? "Tablet theme for the selected non-profit has been updated successfully!" : "Error updating tablet theme",
      isLoading: false
    });
  };
  render() {
    const {
      nonProfit,
      nonProfitId,
      nonProfitOptions,
      tablet,
      xhrMessage,
      xhrStatus
    } = this.state;
    const pickerStyles = {
      default: {
        picker: {
          width: '300px'
        }
      }
    }
    return (
      <Container fluid>
        <Segment basic textAlign="center">
        {nonProfitOptions && <Dropdown
            onChange={this.handleNonProfit}
            options={nonProfitOptions}
            placeholder="Select Non-profit"
            search
            selection
            value={+nonProfitId}
          />}
        </Segment>
        {nonProfit && nonProfitId > 0 && (
          <Segment basic>
            <Grid>
              <Grid.Row>
                <Grid.Column width={6}>
                  <Message
                    hidden={xhrStatus === ""}
                    content={xhrMessage}
                    success={xhrStatus === "success"}
                    error={xhrStatus === "error"}
                  />
                  <Segment basic>
                    Main{" "}
                    {nonProfit.alt1_text && <Popup
                    basic
                    style={{ padding: 0, boxShadow: 0 }}
                    trigger={
                      <Button
                        circular
                        floated="right"
                        icon="font"
                        content="Text"
                        style={{
                          backgroundColor: nonProfit.alt1_text,
                          color: invertColor(nonProfit.alt1_text, 1)
                        }}
                      />
                    }
                    content={
                      <ChromePicker
                        color={nonProfit.alt1_text}
                        onChangeComplete={this.handleAlt1Text}
                        disableAlpha={true}
                        styles={pickerStyles}
                      />
                    }
                    on="click"
                    position="bottom center"
                  />
                  } 
                  {nonProfit.alt1_bg && <Popup
                    basic
                    style={{ padding: 0, boxShadow: 0 }}
                    trigger={
                      <Button
                        circular
                        floated="right"
                        icon="paint brush"
                        content="Background"
                        style={{
                          backgroundColor: nonProfit.alt1_bg,
                          color: invertColor(nonProfit.alt1_bg, 1)
                        }}
                      />
                    }
                    content={
                      <ChromePicker
                        color={nonProfit.alt1_bg}
                        onChangeComplete={this.handleAlt1Bg}
                        disableAlpha={true}
                        styles={pickerStyles}
                      />
                    }
                    on="click"
                    position="bottom left"
                    />
                  }
                  </Segment>
                  <Segment basic>
                    Secondary{" "}
                    {nonProfit.alt2_text && <Popup
                    basic
                    style={{ padding: 0, boxShadow: 0 }}
                    trigger={
                      <Button
                        circular
                        floated="right"
                        icon="font"
                        content="Text"
                        style={{
                          backgroundColor: nonProfit.alt2_text,
                          color: invertColor(nonProfit.alt2_text, 2)
                        }}
                      />
                    }
                    content={
                      <ChromePicker
                        color={nonProfit.alt2_text}
                        onChangeComplete={this.handleAlt2Text}
                        disableAlpha={true}
                        styles={pickerStyles}
                      />
                    }
                    on="click"
                    position="bottom center"
                  />
                    }
                    {nonProfit.alt2_bg && <Popup
                      basic
                      style={{ padding: 0, boxShadow: 0 }}
                      trigger={
                        <Button
                          circular
                          floated="right"
                          icon="paint brush"
                          content="Background"
                          style={{
                            backgroundColor: nonProfit.alt2_bg,
                            color: invertColor(nonProfit.alt2_bg, 2)
                          }}
                        />
                      }
                      content={
                        <ChromePicker
                          color={nonProfit.alt2_bg}
                          onChangeComplete={this.handleAlt2Bg}
                          disableAlpha={true}
                          styles={pickerStyles}
                        />
                      }
                      on="click"
                      position="bottom left"
                    />
                    }
                  </Segment>
                  <Segment basic>
                    Highlight{" "}
                    {nonProfit.hl1_text && <Popup
                      basic
                      style={{ padding: 0, boxShadow: 0 }}
                      trigger={
                        <Button
                          circular
                          floated="right"
                          icon="font"
                          content="Text"
                          style={{
                            backgroundColor: nonProfit.hl1_text,
                            color: invertColor(nonProfit.hl1_text, 2)
                          }}
                        />
                      }
                      content={
                        <ChromePicker
                          color={nonProfit.hl1_text}
                          onChangeComplete={this.handleHl1Text}
                          disableAlpha={true}
                          styles={pickerStyles}
                        />
                      }
                      on="click"
                      position="bottom left"
                    />}
                    {nonProfit.hl1_bg && <Popup
                      basic
                      style={{ padding: 0, boxShadow: 0 }}
                      trigger={
                        <Button
                          circular
                          floated="right"
                          icon="paint brush"
                          content="Background"
                          style={{
                            backgroundColor: nonProfit.hl1_bg,
                            color: invertColor(nonProfit.hl1_bg, 2)
                          }}
                        />
                      }
                      content={
                        <ChromePicker
                          color={nonProfit.hl1_bg}
                          onChangeComplete={this.handleHl1Bg}
                          disableAlpha={true}
                          styles={pickerStyles}
                        />
                      }
                      on="click"
                      position="bottom left"
                    />}
                  </Segment>
                  <Segment basic>
                    Spacer{" "}
                    {nonProfit.spacerbar && <Popup
                      basic
                      style={{ padding: 0, boxShadow: 0 }}
                      trigger={
                        <Button
                          circular
                          floated="right"
                          icon="paint brush"
                          content="Background"
                          style={{
                            backgroundColor: nonProfit.spacerbar,
                            color: invertColor(nonProfit.spacerbar, 2)
                          }}
                        />
                      }
                      content={
                        <ChromePicker
                          color={nonProfit.spacerbar}
                          onChangeComplete={this.handleSpacerBar}
                        />
                      }
                      on="click"
                      position="bottom left"
                    />}
                  </Segment>
                  <Button
                    primary
                    floated="right"
                    onClick={this.handleSubmit}
                    icon="save"
                    content="Submit"
                  />
                </Grid.Column>
                <Grid.Column width={10}>
                  <Segment
                    padded="very"
                    inverted
                    style={{ maxWidth: "640px", margin: "0 auto" }}
                  >
                    <Grid relaxed container textAlign="center">
                      <Grid.Row style={{ backgroundColor: "#fff" }}>
                        <Grid.Column width={4}>
                          <DropzoneCommon
                            img={tablet.left}
                            accept="image/*"
                            onDrop={this.handleTabletLeft}
                          />
                        </Grid.Column>
                        <Grid.Column width={8}>
                          <Image src="https://react.semantic-ui.com/images/wireframe/paragraph.png" />
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <DropzoneCommon
                            img={tablet.right}
                            accept="image/*"
                            onDrop={this.handleTabletRight}
                          />
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row
                        columns={1}
                        style={{
                          backgroundColor: nonProfit.alt1_bg,
                          borderTop: "2px solid " + nonProfit.spacerbar
                        }}
                      >
                        <Grid.Column
                          children={
                            <Header
                              as="h1"
                              style={{ color: nonProfit.alt1_text }}
                            >
                              1 Tickets $5
                          </Header>
                          }
                        />
                      </Grid.Row>
                      <Grid.Row
                        columns={1}
                        style={{
                          backgroundColor: nonProfit.alt1_bg,
                          borderTop: "2px solid " + nonProfit.spacerbar
                        }}
                      >
                        <Grid.Column
                          style={{ backgroundColor: nonProfit.alt1_bg }}
                          children={
                            <Header
                              as="h1"
                              style={{ color: nonProfit.alt1_text }}
                            >
                              3 Tickets $10
                          </Header>
                          }
                        />
                      </Grid.Row>
                      <Grid.Row
                        columns={1}
                        style={{
                          backgroundColor: nonProfit.hl1_bg,
                          borderTop: "2px solid " + nonProfit.spacerbar
                        }}
                      >
                        <Grid.Column
                          style={{ backgroundColor: nonProfit.hl1_bg }}
                          children={
                            <Header
                              as="h1"
                              style={{ color: nonProfit.hl1_text }}
                            >
                              10 Tickets $20
                          </Header>
                          }
                        />
                      </Grid.Row>
                      <Grid.Row
                        columns={1}
                        style={{
                          backgroundColor: nonProfit.alt1_bg,
                          borderTop: "2px solid " + nonProfit.spacerbar
                        }}
                      >
                        <Grid.Column
                          style={{ backgroundColor: nonProfit.alt1_bg }}
                          children={
                            <Header
                              as="h1"
                              style={{ color: nonProfit.alt1_text }}
                            >
                              50 Tickets $50
                          </Header>
                          }
                        />
                      </Grid.Row>
                      <Grid.Row
                        columns={1}
                        style={{
                          backgroundColor: nonProfit.alt2_bg,
                          borderTop: "12px solid " + nonProfit.spacerbar,
                          borderBottom: "12px solid " + nonProfit.spacerbar
                        }}
                      >
                        <Grid.Column
                          children={
                            <Header
                              as="h1"
                              style={{ color: nonProfit.alt2_text }}
                            >
                              Tickets: 0<br />
                            Total: $0
                          </Header>
                          }
                        />
                      </Grid.Row>
                      <Grid.Row
                        columns={2}
                        style={{ backgroundColor: nonProfit.alt1_bg }}
                      >
                        <Grid.Column
                          children={
                            <Button fluid color="red">
                              Reset
                          </Button>
                          }
                        />
                        <Grid.Column
                          children={
                            <Button fluid color="green">
                              Next
                          </Button>
                          }
                        />
                      </Grid.Row>
                    </Grid>
                  </Segment>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        )}
      </Container>
    );
  }
}

export default Tablet;
